import { render, staticRenderFns } from "./EntregaDestinoUpdate.vue?vue&type=template&id=10213cde"
import script from "./EntregaDestinoUpdate.vue?vue&type=script&lang=js"
export * from "./EntregaDestinoUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports